<template>
  <div id="content">
    <Map v-if="myLocation" class="map"/>
    <SearchPC v-if="isPC && places" class="search-pc"/>
    <SearchSP v-if="isSP && places" class="search-sp"/>
    <Genre v-if="places" class="genre"/>
    <Location v-if="myLocation" class="location"/>
    <transition v-if="isPC" name="slide">
      <DetailPC v-if="selectedPlace" class="detail-pc"/>
    </transition>
    <transition v-if="isSP" name="slide">
      <DetailSP v-if="selectedPlace" class="detail-sp"/>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import Map from '@/components/Home/Map.vue'
import SearchPC from '@/components/Home/Search.pc.vue'
import SearchSP from '@/components/Home/Search.sp.vue'
import Genre from '@/components/Home/Genre.vue'
import Location from '@/components/Home/Location.vue'
import DetailPC from '@/components/Home/Detail.pc.vue'
import DetailSP from '@/components/Home/Detail.sp.vue'

export default defineComponent({
  name: 'Content',
  components: {
    Map,
    SearchPC,
    SearchSP,
    Genre,
    Location,
    DetailPC,
    DetailSP,
  },
  computed: {
    ...mapGetters(['places', 'isPC', 'isSP']),
    ...mapState(['myLocation', 'selectedPlace']),
  },
})
</script>

<style scoped lang="scss">
#content {
  position: relative;
  width: 100%;
  height: 40vw;
  min-height: 600px;
  border-bottom: 1px solid #EEEEEE;

  .map {
    position: absolute;
    top: 0;
    left: 0;
  }

  .search-pc {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 50001;
  }

  .search-sp {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 50003;
  }

  .genre {
    position: absolute;
    bottom: 18px;
    left: 0;
    z-index: 50000;
  }

  .location {
    position: absolute;
    bottom: 18px;
    right: 13px;
    z-index: 50000;
  }

  .detail-pc {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 50002;
    transform: translateX(0);

    &.slide-enter-active, &.slide-leave-active {
      transition: transform 0.2s;
    }
    &.slide-enter-from, &.slide-leave-to {
      transform: translateX(100%);
    }
  }

  .detail-sp {
    position: absolute;
    top: calc(51vh - 50px);
    height: 531px;
    left: 0;
    right: 0;
    z-index: 50002;
    transform: translateY(0);

    &.slide-enter-active, &.slide-leave-active {
      transition: transform 0.2s;
    }
    &.slide-enter-from, &.slide-leave-to {
      transform: translateY(100%);
    }
  }
}

@media screen and (max-width: 767px) {
  #content {
    height: 72vh;
    min-height: 0;
    max-height: 600px;

    .location {
      bottom: auto;
      right: 10px;
      top: 68px;
    }
  }
}
</style>
